import { measure } from './performance.js';
// Reads may recover from a short connection/server interruption. Writes never retry.
export async function resilientFetch(url, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  for (let attempt = 0; ; attempt++) {
    const controller = new AbortController();
    const abort = () => controller.abort(options.signal.reason);
    if (options.signal?.aborted) abort();
    options.signal?.addEventListener('abort', abort, { once: true });
    const timer = setTimeout(() => controller.abort(new DOMException('Request timed out', 'TimeoutError')), 12000);
    let retry = false;
    const started = globalThis.performance?.now();
    try {
      const response = await globalThis.fetch(url, { ...options, signal: controller.signal });
      if (started != null) measure('polka:request', { start: started, duration: performance.now() - started, detail: { method, status: response.status } });
      retry = method === 'GET' && attempt === 0 && [502, 503, 504].includes(response.status);
      if (!retry) return response;
      await response.body?.cancel();
    } catch (error) {
      retry = method === 'GET' && attempt === 0 && !controller.signal.aborted && error instanceof TypeError;
      if (!retry) throw error;
    } finally {
      clearTimeout(timer); options.signal?.removeEventListener('abort', abort);
    }
    if (options.signal?.aborted) throw options.signal.reason;
    await new Promise(resolve => setTimeout(resolve, 250));
  }
}

const writes = new Map();
export function coalesceWrite(key, action) {
  if (writes.has(key)) return writes.get(key);
  const promise = Promise.resolve().then(action);
  writes.set(key, promise);
  const cleanup = () => { if (writes.get(key) === promise) writes.delete(key); };
  promise.then(cleanup, cleanup);
  return promise;
}
